import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useProductTour } from "./ProductTourProvider";
import { Sparkles, ArrowRight, X } from "lucide-react";

export function WelcomeTourModal() {
  const { showWelcomeModal, setShowWelcomeModal, startTour, skipAllTours } = useProductTour();

  const handleStartTour = () => {
    setShowWelcomeModal(false);
    setTimeout(() => {
      startTour('main');
    }, 300);
  };

  const handleSkip = () => {
    setShowWelcomeModal(false);
    skipAllTours();
  };

  const handleDismiss = (open: boolean) => {
    if (!open) handleSkip();
  };

  return (
    <Dialog open={showWelcomeModal} onOpenChange={handleDismiss}>
      <DialogContent className="sm:max-w-md p-0 bg-card border-border overflow-hidden">
        <DialogTitle className="sr-only">Welcome to LimePhone</DialogTitle>
        <div className="relative">
          <div className="absolute top-4 right-4 z-10">
            <button
              onClick={handleSkip}
              className="p-2 rounded-full hover:bg-surface-elevated text-text-layer-muted hover:text-text-layer-primary transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          
          <div className="bg-gradient-to-br from-primary/20 via-background to-card p-8 text-center">
            <div className="w-20 h-20 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-6 animate-pulse">
              <Sparkles className="h-10 w-10 text-primary" />
            </div>
            
            <h2 className="text-2xl font-bold text-text-layer-primary mb-2">
              Welcome to LimePhone! 🎉
            </h2>
            <p className="text-text-layer-secondary text-sm max-w-xs mx-auto">
              Let's take a quick 2-minute tour so you can start closing deals faster.
            </p>
          </div>
          
          <div className="p-6 space-y-4">
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <span className="text-sm font-semibold text-primary">1</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-text-layer-primary">Your workspace</p>
                  <p className="text-xs text-text-layer-muted">Navigate like a pro</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <span className="text-sm font-semibold text-primary">2</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-text-layer-primary">Inbox & conversations</p>
                  <p className="text-xs text-text-layer-muted">Never miss a customer</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3 p-3 rounded-lg bg-background border border-border">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                  <span className="text-sm font-semibold text-primary">3</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-text-layer-primary">Quick actions</p>
                  <p className="text-xs text-text-layer-muted">Work faster with shortcuts</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col gap-2 pt-2">
              <Button 
                onClick={handleStartTour}
                className="w-full h-12 bg-primary hover:bg-primary/90 text-white font-medium"
              >
                Show Me Around
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
              
              <Button
                variant="ghost"
                onClick={handleSkip}
                className="w-full text-text-layer-muted hover:text-text-layer-primary hover:bg-transparent"
              >
                I'll explore on my own
              </Button>
            </div>
            
            <p className="text-center text-xs text-text-layer-muted">
              Takes about 2 minutes
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
